var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TotemButton',{staticClass:"logout-menu",attrs:{"color":"primary","label":_vm.$t('Menu.log_out'),"fullWidth":true,"iconPosition":"right","icon":"exit"},on:{"click":_vm.toggleLoginMenu}})
}
var staticRenderFns = []

export { render, staticRenderFns }